import { html, LitElement } from 'lit';

import heic2any from 'heic2any';

export default class FormWebComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    name: { type: String },
    data: { type: Object },
    env: { type: String },
    activeFormId: { type: String },
    _displayFormId: { state: true },
    _loading: { state: true }
  };

  constructor() {
    super();
    this.name = 'Form Web Component';
    this.data = {};
    this.env = 'prod';
    this.activeFormId = null;
    this._displayFormId = null;
    this._loading = false;
  }

  updated(changedProperties) {
    if (changedProperties.has('activeFormId')) {
      const prev = changedProperties.get('activeFormId');
      if (prev) {
        this._loading = true;
        setTimeout(() => {
          this._displayFormId = this.activeFormId;
          this._loading = false;
        }, 900);
      } else {
        this._displayFormId = this.activeFormId;
      }
    }
  }

  firstUpdated() {
    // Inject loader styles once into the document
    if (!document.getElementById('form-period-loader-styles')) {
      const style = document.createElement('style');
      style.id = 'form-period-loader-styles';
      style.textContent = `
        .form-period-loader {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 220px;
        }
        .form-period-loader__spinner {
          width: 44px;
          height: 44px;
          border: 4px solid rgba(0, 0, 0, 0.12);
          border-top-color: #333;
          border-radius: 50%;
          animation: form-period-spin 0.75s linear infinite;
        }
        @keyframes form-period-spin {
          to { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }

    this.handleHeicUpload();

    const validView3 = setInterval(() => {
      const fieldUpload = document.querySelector('.upload-text');

      if ($('.upload-text').length > 0) {
        // Mientras el div tenga nodos hijos, elimina el primer hijo
        while (fieldUpload.firstChild) {
          fieldUpload.removeChild(fieldUpload.firstChild);
        }

        // crear un div para envolver el nuevo icono y los textos
        const newUploadDiv = document.createElement('div');
        newUploadDiv.classList.add('new-upload-div');

        // Crear un nuevo elemento para el título
        const newTitle = document.createElement('span');
        newTitle.classList.add('upload-text__title');
        newTitle.textContent = 'UPLOAD RECEIPT';

        // Crear un nuevo elemento para la información
        const newInfo = document.createElement('span');
        newInfo.classList.add('upload-text__info');
        newInfo.textContent =
          'Click to upload or drag and drop JPG, PNG, JPEG, HEIC, HEIF & PDF (Max 30MB)';

        newUploadDiv.appendChild(newTitle);
        newUploadDiv.appendChild(newInfo);

        fieldUpload.appendChild(newUploadDiv);

        clearInterval(validView3);
      }
    }, 100);
  }

  handleHeicUpload() {
    // Regex for case-insensitive file extension check: .heic, .HEIC, .heif, .HEIF
    const isHeicExtension = (fileName) => /\.(heic|heif)$/i.test(fileName);

    document.addEventListener(
      'change',
      async (e) => {
        // console.log('Change event detected on:', e);

        if (e.target && e.target.id === 'upload_receipt-input-upload') {
          const file = e.target.files[0];
          // console.log('File selected:', file.name, file.type);

          // Robust check: valid if MIME type matches or if extension matches (handling Uppercase/Lowercase)
          const isHeicFile =
            file &&
            (file.type === 'image/heic' ||
              file.type === 'image/heif' ||
              isHeicExtension(file.name));

          if (isHeicFile) {
            // console.log('HEIC/HEIF detected, starting conversion...');
            // Stop the event from reaching the default handler immediately
            e.preventDefault();
            e.stopImmediatePropagation();

            const originalTarget = e.target;
            const loadingDiv = document.getElementById('load-upload_receipt');

            // Visual feedback (optional but recommended)
            if (loadingDiv) {
              loadingDiv.style.opacity = '0.5';
              loadingDiv.style.pointerEvents = 'none';
            }

            try {
              console.log('Calling heic2any...');
              // Convert to JPEG
              const convertedBlob = await heic2any({
                blob: file,
                toType: 'image/jpeg',
                quality: 0.8
              });
              // console.log('Conversion successful:', convertedBlob);

              // Handle both single Blob and array of Blobs result
              const blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

              // Create new File object
              const newFile = new File([blob], file.name.replace(/\.(heic|heif)$/i, '.jpg'), {
                type: 'image/jpeg',
                lastModified: new Date().getTime()
              });

              // Create DataTransfer to update input.files

              const dataTransfer = new DataTransfer();
              dataTransfer.items.add(newFile);
              originalTarget.files = dataTransfer.files;

              // Restore UI state
              if (loadingDiv) {
                loadingDiv.style.opacity = '1';
                loadingDiv.style.pointerEvents = 'auto';
              }

              // console.log('Re-dispatching change event with new JPEG file...');
              // Re-dispatch change event to trigger existing logic
              // Since file type is now image/jpeg, this handler won't check it again
              const newEvent = new Event('change', { bubbles: true });
              originalTarget.dispatchEvent(newEvent);
            } catch (error) {
              // console.error('HEIC conversion error details:', error);
              if (loadingDiv) {
                loadingDiv.style.opacity = '1';
                loadingDiv.style.pointerEvents = 'auto';
              }
              // Show error
              const errorSpan = document.getElementById('error-upload_receipt');
              if (errorSpan) {
                // Show the specific error message to help debugging
                errorSpan.textContent =
                  'Error: Invalid format. Please upload JPG, PNG, HEIC, HEIF.';
                errorSpan.style.display = 'block';
              }
            }
          }
        }
      },
      true
    ); // Use capture phase to intercept before other listeners
  }

  render() {
    const { env, _displayFormId, _loading } = this;

    if (_loading) {
      return html`
        <section class="form-component">
          <div class="form-period-loader">
            <div class="form-period-loader__spinner"></div>
          </div>
        </section>
      `;
    }

    return html`
      ${!_displayFormId
        ? ''
        : html`
            <section class="form-component">
              <universal-form-webcomponent
                program_id="${_displayFormId}"
                env="${env}"
                case="getData"
              >
              </universal-form-webcomponent>
            </section>
          `}
    `;
  }
}

customElements.define('form-webcomponent', FormWebComponent);
